import React from "react";
import { Link, NavLink } from "react-router-dom";
import { LogIn, UserPlus, LogOut } from "lucide-react";
import { LOGO_URL } from "../lib/brand";
import { useAuth } from "../context/AuthContext";

export default function Navbar() {
  const { user, logout } = useAuth();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center">
            <img src={LOGO_URL} alt="ALearn India" className="h-12 w-auto object-contain" />
          </Link>

          <nav className="hidden md:flex space-x-10">
            <NavLink to="/" className={({ isActive }) => `text-sm font-semibold ${isActive ? "text-[#FFC107] border-b-2 border-[#FFC107] pb-1" : "text-gray-600 hover:text-gray-900"}`}>
              Home
            </NavLink>
            <NavLink to="/courses" className={({ isActive }) => `text-sm font-semibold ${isActive ? "text-[#FFC107] border-b-2 border-[#FFC107] pb-1" : "text-gray-600 hover:text-gray-900"}`}>
              Courses
            </NavLink>
            <NavLink to="/about" className={({ isActive }) => `text-sm font-semibold ${isActive ? "text-[#FFC107] border-b-2 border-[#FFC107] pb-1" : "text-gray-600 hover:text-gray-900"}`}>
              About Us
            </NavLink>
          </nav>

          <div className="flex items-center space-x-6">
            {user ? (
              <div className="flex items-center space-x-6">
                <Link 
                  to={user.role === "admin" ? "/admin" : "/dashboard"} 
                  className="flex items-center gap-2.5 text-sm font-semibold text-[#0A192F] hover:text-[#FF6B35] transition duration-200"
                  data-testid="navbar-profile-link"
                >
                  <div className="w-9 h-9 rounded-full bg-orange-50 text-[#FF6B35] border border-orange-100 flex items-center justify-center font-bold text-xs uppercase shrink-0">
                    {user?.name ? user.name.split(" ").map(n => n[0]).join("").slice(0, 2) : "U"}
                  </div>
                  <span className="hidden sm:inline">Hello, {user?.name ? user.name.split(" ")[0] : "Learner"}</span>
                </Link>
                <button 
                  onClick={logout}
                  className="flex items-center text-sm font-semibold text-gray-600 hover:text-red-500 transition duration-200"
                  data-testid="navbar-logout-btn"
                >
                  <LogOut className="w-4 h-4 mr-2" />
                  Sign Out
                </button>
              </div>
            ) : (
              <>
                <Link to="/login" className="flex items-center text-sm font-semibold text-gray-700 hover:text-gray-900">
                  <LogIn className="w-4 h-4 mr-2" />
                  Login
                </Link>
                <Link to="/login" className="btn-yellow flex items-center px-6 py-2.5">
                  <UserPlus className="w-4 h-4 mr-2" />
                  Sign Up
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
